import { render, staticRenderFns } from "./organization_edit_form.vue?vue&type=template&id=18b1550c&scoped=true&"
import script from "./organization_edit_form.vue?vue&type=script&lang=js&"
export * from "./organization_edit_form.vue?vue&type=script&lang=js&"
import style0 from "./organization_edit_form.vue?vue&type=style&index=0&id=18b1550c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1550c",
  null
  
)

export default component.exports